"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertToTemplatePanel = void 0;
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var CallToAction_1 = __importDefault(require("Project/Actions/CallToActions/CallToAction"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ConvertToTemplatePanel = function (_a) {
    var projectStore = _a.projectStore;
    var projectService = (0, inversify_react_1.useInjection)("projectService");
    return (react_1.default.createElement(kaleidoscope_1.Panel, { className: "convert-to-template-panel" },
        react_1.default.createElement(CallToAction_1.default, { text: "Turn any Qwilr Page into a template, and use Tokens to personalise it.", image: react_1.default.createElement("img", { src: "/Assets/Images/onboarding-tokens.png" }), primaryButtonAction: function () {
                return new Promise(function (resolve) { return setTimeout(function () { return resolve(projectService.addAsTemplate(projectStore)); }, 200); });
            }, primaryButtonText: "Convert page to template", learnMoreHref: "https://help.qwilr.com/article/730-personalizing-qwilr-pages-with-tokens" })));
};
exports.ConvertToTemplatePanel = ConvertToTemplatePanel;
